function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Welcome",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-Login",
  transform: "translate(-434.000000, -54.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Header",
  transform: "translate(434.000000, 54.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "LogoW"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("rect", {
  className: "rect1",
  id: "Rectangle",
  stroke: "#FFFFFF",
  strokeWidth: 1,
  x: 0.5,
  y: 11.4714286,
  width: 60.0285714,
  height: 60.0285714
}), /*#__PURE__*/React.createElement("rect", {
  className: "rect2",
  id: "Rectangle",
  stroke: "#FFFFFF",
  strokeWidth: 1,
  x: 5.98571429,
  y: 5.98571429,
  width: 60.0285714,
  height: 60.0285714
}), /*#__PURE__*/React.createElement("rect", {
  className: "rect3",
  id: "Rectangle",
  stroke: "#FFFFFF",
  strokeWidth: 1,
  x: 11.4714286,
  y: 0.5,
  width: 60.0285714,
  height: 60.0285714
}), /*#__PURE__*/React.createElement("rect", {
  className: "logo-text",
  id: "Rectangle",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  x: 16.4571429,
  y: 40.5428571,
  width: 15,
  height: 15
}), /*#__PURE__*/React.createElement("text", {
  className: "logo-text",
  id: "SOURCEBOX",
  fontFamily: "LucidaGrande, Lucida Grande, 'Open Sans'",
  fontSize: 16,
  fontWeight: "normal",
  "line-spacing": 18,
  letterSpacing: 2,
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 35.6796875,
  y: 54
}, "SOURCEBOX")))))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "145px",
    height: "72px",
    viewBox: "0 0 145 72",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.cfa14970.svg";
export { ForwardRef as ReactComponent };